import { render, staticRenderFns } from "./VInviteModal.vue?vue&type=template&id=640c8c81&"
import script from "./VInviteModal.vue?vue&type=script&lang=ts&"
export * from "./VInviteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports